import { render, staticRenderFns } from "./CountdownScreen.vue?vue&type=template&id=6495c602&scoped=true&"
import script from "./CountdownScreen.vue?vue&type=script&lang=js&"
export * from "./CountdownScreen.vue?vue&type=script&lang=js&"
import style0 from "./CountdownScreen.vue?vue&type=style&index=0&id=6495c602&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6495c602",
  null
  
)

export default component.exports